export const Skeleton = () => {
  return (
    <div className="tw-space-y-4 tw-p-4 tw-pt-[120px]">
      {Array.from({ length: 3 }).map((_, index) => (
        <div
          className="tw-animate-[pulse_.8s_linear_infinite] tw-rounded-lg tw-border tw-border-solid tw-border-blue-50 tw-bg-white"
          key={index}
        >
          <div className="tw-space-y-4 tw-p-4 tw-pt-3">
            <span className="tw-block tw-size-7 tw-rounded-full tw-bg-[linear-gradient(90deg,_#E7E6EC_0%,_#F2F1F7_100%)]"></span>
            <span className="tw-block tw-h-2 tw-rounded-[100px] tw-bg-[linear-gradient(90deg,_#E7E6EC_0%,_#F2F1F7_100%)]"></span>
            <span className="tw-block tw-h-2 tw-rounded-[100px] tw-bg-[linear-gradient(90deg,_#E7E6EC_0%,_#F2F1F7_100%)]"></span>
            <span className="tw-block tw-h-2 tw-w-[70%] tw-rounded-[100px] tw-bg-[linear-gradient(90deg,_#E7E6EC_0%,_#F2F1F7_100%)]"></span>
          </div>
          <div className="tw-border-t tw-border-t-blue-50 tw-p-4">
            <span className="tw-block tw-h-5"></span>
          </div>
        </div>
      ))}
    </div>
  );
};
